
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLogic06Off as ObiLogic06OffElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-logic-06-off.js';
 
 
 

 
 export const ObiLogic06Off = createComponent({
   react: React,
   tagName: 'obi-logic-06-off',
   elementClass: ObiLogic06OffElement,
   events: {
     
   }
  });
 
 